<template>
  <LayoutDashboard title="NCM">
    <v-card outlined>
      <v-card-title>
        <v-btn color="primary" outlined @click="cadastrarNCM()"
          >Cadastrar</v-btn
        >
        <v-btn class="ml-2" color="default" @click="setModalAtualizarTabelaNCM(true)" outlined>Atualizar tabela IBPT</v-btn>
        <v-spacer></v-spacer>
        <h3>Registros: {{ getNCMs.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getNCMs.current_page"
          :length="getNCMs.last_page"
          @input="listarNCMs({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.codigo"
                    outlined
                    dense
                    label="Código"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    v-model="dataPagina.descricao"
                    outlined
                    dense
                    label="Descrição"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="10%" align="center">
                  <v-select
                    outlined
                    label="Exibir"
                    dense
                    :items="[10, 20, 30, 40, 50]"
                    item-value="value"
                    item-text="label"
                    v-model="dataPagina.limit"
                    @change="listarContaPagar({ ...dataPagina })"
                    class="mt-2"
                  ></v-select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="n in getNCMs.data" :key="n.id">
                <td align="center">{{ n.codigo }}</td>
                <td>{{ n.descricao }}</td>
                <td align="center">
                  <TooltipButton
                    @click.native="visualizarNCM(n)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="$helper.verificaPermissao('visualizar-ncm')"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
    <ModalCadastro />
    <ModalAtualizarTabela /> 
  </LayoutDashboard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalCadastro from "@/pages/ncm/ModalCadastro";
import ModalAtualizarTabela from "@/pages/ncm/ModalAtualizarTabela";
var _ = require("lodash");

export default {
  components: {
    ModalCadastro,
    ModalAtualizarTabela,
  },
  data() {
    return {
      dataPagina: {
        codigo: "",
        descricao: "",
        page: "",
        limit: 20,
      },
    };
  },
  computed: {
    ...mapGetters(["getNCMs"]),
  },
  methods: {
    ...mapActions(["cadastrarNCM", "listarNCMs", "visualizarNCM", "setModalAtualizarTabelaNCM"]),
    pesquisar() {
      this.listarNCMs(this.dataPagina);
    },
  },
  created() {
    this.listarNCMs(this.dataPagina);
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>